import React from 'react'
import PropTypes from 'prop-types'

function RestoreButtonWithRecords ({ records }) {
  return <div className="d-flex align-items-center w-100 mb-2">
    <div className="track-blue-button deleted-records">
      Restore Checked Records
    </div>
    <div className="deleted-records-total">{records} Records Found</div>
  </div>
}

RestoreButtonWithRecords.propTypes = {
  records: PropTypes.number
}

export default RestoreButtonWithRecords



// WEBPACK FOOTER //
// ./src/components/ManagementDeletedRecordsArchive/components/RestoreButtonWithRecords.js